import { jsx as l, jsxs as s } from "react/jsx-runtime";
import { Skeleton as N, FormControl as v, InputLabel as F, Select as D, ListSubheader as L, MenuItem as b } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import "../../pointsGraph-DTJju-rA.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import { forms as f } from "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { useState as I, useEffect as c } from "react";
import w from "@mui/icons-material/PriorityHigh";
const ir = ({ studentId: h, onChange: a, selected: u, includeExpired: g, year: p }) => {
  const [P, C] = I(String(u)), [d, E] = I([]), { data: o } = new f.FormListStudents().ToQuery(), { data: m } = new f.StudentSummary({ studentId: h, includeExpired: g ? 1 : 0, ...p !== void 0 && { year: p } }).ToQuery(), S = (r) => {
    var e, i;
    console.log(o), a({ formId: Number(r.target.value), CanAdd: ((e = o == null ? void 0 : o.find((t) => t.Id == Number(r.target.value))) == null ? void 0 : e.CanAdd) ?? !1, Expires: ((i = o == null ? void 0 : o.find((t) => t.Id == Number(r.target.value))) == null ? void 0 : i.Expires) ?? !1 }), C(r.target.value);
  };
  return c(() => {
    if (o == null)
      return;
    let r = o.sort((t, n) => t.ParentId === null && n.ParentId !== null ? -1 : t.ParentId !== null && n.ParentId === null ? 1 : t.Id - n.Id), e = /* @__PURE__ */ new Map();
    r.forEach((t) => {
      t.ParentId !== null && (e.has(t.ParentId) || e.set(t.ParentId, []), e.get(t.ParentId).push(t));
    }), r = r.sort((t, n) => t.Name.localeCompare(n.Name));
    let i = [];
    r.forEach((t) => {
      t.ParentId === null && (i.push(t), e.has(t.Id) && e.get(t.Id).forEach((n) => i.push(n)));
    }), E(i);
  }, [o]), d ? (c(() => {
    if (!d)
      return;
    let r = d.find((e) => e.Id == u);
    r && a({ formId: Number(r.Id), CanAdd: r.CanAdd, Expires: r.Expires });
  }, [d]), /* @__PURE__ */ s(v, { sx: { minWidth: 250, maxWidth: 250 }, children: [
    /* @__PURE__ */ l(F, { htmlFor: "grouped-native-select", children: "Form" }),
    /* @__PURE__ */ l(
      D,
      {
        id: "grouped-native-select",
        label: "Form",
        value: P,
        onChange: S,
        children: d.map(
          (r) => {
            var e, i;
            return r.ParentId == null ? /* @__PURE__ */ l(L, { children: r.Name }, r.Id) : /* @__PURE__ */ s(
              b,
              {
                value: r.Id,
                children: [
                  r.Name,
                  " ",
                  m == null || ((e = m.find((t) => t.FormID == r.Id)) == null ? void 0 : e.RecordCount) == 0 ? "" : `(${(i = m.find((t) => t.FormID == r.Id)) == null ? void 0 : i.RecordCount})`,
                  r.HighPriority && /* @__PURE__ */ l(w, { sx: { color: "var(--mui-palette-warning-main)" } })
                ]
              },
              r.Id
            );
          }
        )
      }
    )
  ] })) : /* @__PURE__ */ l(N, {});
};
export {
  ir as RecordListDropDown
};
//# sourceMappingURL=RecordListDropdown.js.map
